import { lazy } from "react";

// project imports
import Loadable from "../components/molecules/Berry/Loadable";
import { Outlet } from "react-router-dom";
import KalendarGuard from "../components/atoms/route-guard/KalendarGuard";

// dashboard routing
const KalendarPage = Loadable(
  lazy(() => import("../components/pages/kalendar"))
);
const NotAllowedPage = Loadable(
  lazy(() => import("../components/pages/notAllowedPage"))
);
const Error = Loadable(lazy(() => import("../components/pages/errorPage")));
// ==============================|| MAIN ROUTING ||============================== //

const KalendarRoutes = {
  path: "/",
  element: (
    <KalendarGuard>
      <Outlet />
    </KalendarGuard>
  ),
  children: [
    {
      path: "/app/kalendar",
      element: <KalendarPage />,
    },
    {
      path: "/app/not-allowed",
      element: <NotAllowedPage />,
    },
    {
      path: "/app/error",
      element: <Error />,
    },
    {
      path: "*",
      element: <Error />,
    },
  ],
};

export default KalendarRoutes;
